module.exports = __webpack_public_path__ + "static/media/carousel9.aa937c78.jpeg";